import script from "./LoomverseInfoView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoomverseInfoView.vue?vue&type=script&setup=true&lang=js"

import "./LoomverseInfoView.vue?vue&type=style&index=0&id=dd055794&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd055794"]])

export default __exports__